import { render, staticRenderFns } from "./FormEvento.vue?vue&type=template&id=eb0d8b26"
import script from "./FormEvento.vue?vue&type=script&lang=js"
export * from "./FormEvento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports